import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { ChatDialog, Chats } from "./components/components";
import { GlobalContext } from "../../context/globalContext";
import { httpAPI_CHA005 } from "./api/request";
import "./components/_style.scss";

/**
 * SCRC090001 チャットボット
 * チャットボット上で任意の問い合わせを行う。
 * @return SCRC090001
 */
const SCRC090001 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);

  const [chats, setChats] = useState<any>([]);

  /**
   * チャットボットシーケンス参照API実行
   * @param sequesnceNo 次のシーケンス番号
   * @param answer 選択
   */
  const handleCallApi = async (sequenceNo: number, answer?: any) => {
    try {
      const res = await httpAPI_CHA005({
        sequenceNo: sequenceNo,
      });

      if (res.resultCd === "I0000") {
        // 選択肢
        const answers = res.sequenceSelectList?.map((item) => ({
          content: item.detail,
          nextId: item.nextSequenceNo,
          path: item.scenePath,
          url: item.url,
        }));

        const fileLists =
          res?.fileName1 || res?.fileName2 || res?.fileName3
            ? [
                { fileName1: res?.fileName1, file1: res?.file1 },
                { fileName2: res?.fileName2, file2: res?.file2 },
                { fileName3: res?.fileName3, file3: res?.file3 },
              ]
            : [];

        // その他
        const select = {
          type: "question",
          question: res.sequenceText,
          answers: answers,
          fileLists: fileLists,
        };

        if (answer) {
          setChats([...chats, answer, select]);
        } else {
          setChats([select]);
        }

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    if (!state.chatOpen) {
      setChats([]);
      return;
    }

    handleCallApi(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.chatOpen]);

  const handleClose = () => {
    setState({
      ...state,
      chatOpen: false,
    });
  };

  const handleChange = (item: any) => {
    let answer = {
      type: "answer",
      question: item.content,
    };
    if (item.url) {
      let label = {
        type: "question",
        question: (
          <>
            {item.content}
            <br />
            <Link to={item.url} target="_blank">
              {item.url}
            </Link>
          </>
        ),
      };

      setChats([...chats, answer, label]);
      return;
    }

    handleCallApi(item.nextId, answer);
  };

  return (
    <Box data-testid="SCRC090001">
      <ChatDialog
        open={state.chatOpen}
        onClose={handleClose}
        content={<Chats chats={chats} onChange={(e: any) => handleChange(e)} />}
      />
    </Box>
  );
};

export default SCRC090001;
